import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, authStore } from "../../api/adminApi";
import { firstAllowedPath } from "../../permissions";
import "./login.scss";

// Demo-only convenience login. Remove before using this portal with non-demo credentials.
const demoAccount = {
  email: "",
  password: "",
};

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const signIn = async (loginEmail, loginPassword) => {
    setErrorMessage(""); setLoading(true);
    try {
      const data = await adminApi.login(loginEmail, loginPassword);
      authStore.save(data.token, data.user);
      navigate(firstAllowedPath(data.user), { replace: true });
    } catch (error) { setErrorMessage(error.message); }
    finally { setLoading(false); }
  };

  const handleLogin = (event) => {
    event.preventDefault();
    signIn(email, password);
  };

  return <div className="login-page">
    <section className="login-page__story">
      <div className="login-page__brand"><span>T</span><div><strong>Traffidio</strong><small>Chatbot Portal</small></div></div>
      <div className="login-page__message"><small>Traffidio by Cloudkia</small><h1>Turn visitor questions into useful insights.</h1><p>Review conversations, understand what riders need and manage the chatbot experience from one simple portal.</p><div className="login-page__status"><i/><div><strong>Service online</strong><span>Traffic and conversations are being recorded</span></div></div></div>
      <p className="login-page__foot">Provided and supported by Cloudkia Solutions</p>
    </section>
    <section className="login-page__panel"><form className="login-page__card" onSubmit={handleLogin}><div className="login-page__mobile-brand">Traffidio <span>Chatbot</span></div><p className="login-page__eyebrow">Administrator access</p><h2>Welcome back</h2><p className="login-page__subtitle">Sign in to manage the Traffidio Chatbot.</p><label>Email address<input type="email" placeholder="name@company.com" value={email} autoComplete="username" onChange={e => { setEmail(e.target.value); setErrorMessage(""); }} required /></label><label>Password<input type="password" placeholder="Enter your password" value={password} autoComplete="current-password" onChange={e => { setPassword(e.target.value); setErrorMessage(""); }} required /></label>{errorMessage && <div className="notice notice--error">{errorMessage}</div>}<button type="submit" disabled={loading}>{loading ? "Signing in…" : "Sign in"}</button><button type="button" className="login-page__demo-button" onClick={() => signIn(demoAccount.email, demoAccount.password)} disabled={loading}>Use demo account</button><small className="login-page__help">Demo credentials are included in this portal build.</small></form></section>
  </div>;
};

export default LoginPage;
